import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import markup from './landing/landing.html?raw';
import { mountLandingPage } from './landing/landingRuntime';
import './landing/LandingPage.css';

const LandingPage: React.FC = () => {
  const rootRef = useRef<HTMLDivElement>(null);
  const runtimeRef = useRef<ReturnType<typeof mountLandingPage> | null>(null);
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    document.documentElement.classList.add('eventik-landing-active');
    document.body.classList.add('eventik-landing-active');

    // The template is a checked-in asset. Restore its source before each setup,
    // including React StrictMode's second setup, so translations start cleanly.
    root.innerHTML = markup;
    const runtime = mountLandingPage(root, {
      language: i18n.language,
      onLanguageChange: (language: string) => {
        localStorage.setItem('eventik-language-explicit', '1');
        void i18n.changeLanguage(language);
      },
      onNavigate: (href: string) => { navigate(href); },
    });
    runtimeRef.current = runtime;
    return () => {
      runtime.destroy();
      runtimeRef.current = null;
      document.documentElement.classList.remove('eventik-landing-active');
      document.body.classList.remove('eventik-landing-active');
    };
  }, [i18n, navigate]);

  useEffect(() => {
    runtimeRef.current?.setLanguage(i18n.language);
  }, [i18n.language]);

  // The runtime owns this subtree, so React updates cannot replace live widgets.
  return <div className="eventik-landing" ref={rootRef} />;
};

export default LandingPage;
